'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { PerpEtcSection } from './perpetual';
import { SpotEtcSection } from './spot';

export const EtcSection = () => {
  const { symbolInfoAtom } = useBunja(tradeSymbolBunja);
  const symbolInfo = useAtomValue(symbolInfoAtom);

  if (symbolInfo?.isSpot) return <SpotEtcSection />;
  return <PerpEtcSection />;
};
